import { KYCStatus } from '../../models/kyc_status.model';
import { MerchantCategory } from '../../models/merchant_category.model';
import { MerchantProfile } from '../../models/merchant_profile.model';
import { OnBoardingProfile } from '../../models/onboarding_profile.model';
import { MerchantState } from './state.interface';

export const InitialMerchantState: MerchantState = {
    businessTypes: [],
    merchantCategory: [],
    merchantLiveCategories: [] as MerchantCategory[],
    merchantDetails: [],
    merchantProfile: {} as MerchantProfile,
    creatingMerchantLiveAccount: false,
    creatingMerchantLiveAccountSuccess: false,
    creatingMerchantLiveAccountFailure: '',
    kycStatus: {} as KYCStatus,
    kycTypes: [],
    onBoardingProfile: {} as OnBoardingProfile,
    addNewBusinessError: '',
    toggledAppMode: 'Test Mode',
    isTogglingAppMode: false,
    isTogglingAppModeSuccess: false,
    isTogglingAppModeFailure: false,
    modeTypeFetching: false,
    modeTypeSuccess: false,
    modeTypeFailure: false,
    getLiveMerchantSuccess: false,
    getLiveMerchantFailure: false,
    invitations: [],
    twoFaSetupData: null,
    twoFaStatusData: null,
    twoFaLoading: false,
    twoFaError: null,
    error: ''
};
